module.exports = __webpack_public_path__ + "img/experian.54bbc9c5.svg";